import React, { createContext, useContext, useState } from "react";
import { IMedicalEmergencyApiResponse } from "../../../../../../services/medical-emergency/typings/IMedicalEmergencyApiResponse";

type MedicalEmergencyContextType = {
  selectedMedicalEmergency: IMedicalEmergencyApiResponse | null;
  setSelectedMedicalEmergency: React.Dispatch<
    React.SetStateAction<IMedicalEmergencyApiResponse | null>
  >;
};

const INITIAL_CONTEXT_STATE: MedicalEmergencyContextType = {
  selectedMedicalEmergency: null,
  setSelectedMedicalEmergency: () => {},
};

export const MedicalEmergencyContext = createContext(INITIAL_CONTEXT_STATE);

export const useMedicalEmergency = () => {
  const context = useContext(MedicalEmergencyContext);
  if (context != undefined) {
    return context;
  } else {
    throw new Error(
      "useMedicalEmergency must be used within MedicalEmergencyProvider"
    );
  }
};

export const MedicalEmergencyProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  const [selectedMedicalEmergency, setSelectedMedicalEmergency] =
    useState<IMedicalEmergencyApiResponse | null>(null);

  return (
    <MedicalEmergencyContext.Provider
      value={{ selectedMedicalEmergency, setSelectedMedicalEmergency }}
    >
      {children}
    </MedicalEmergencyContext.Provider>
  );
};
